"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Plane } from "lucide-react";
const airports = [{
  code: "JFK",
  name: "John F. Kennedy International Airport"
}, {
  code: "LGA",
  name: "LaGuardia Airport"
}, {
  code: "EWR",
  name: "Newark Liberty International Airport"
}, {
  code: "BDL",
  name: "Bradley International Airport"
}, {
  code: "HPN",
  name: "Westchester County Airport"
}, {
  code: "TEB",
  name: "Teterboro Airport"
}];
export default function DetailedLocationsAndAirports() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section ref={sectionRef} className="relative overflow-hidden bg-background py-20 px-6">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/runway_texture_pattern.png)",
      backgroundSize: "400px 400px",
      backgroundRepeat: "repeat",
      animation: "slowScroll 60s linear infinite"
    }} />

      <style jsx>{`
        @keyframes slowScroll {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 400px 400px;
          }
        }
      `}</style>

      <div className="container relative z-10 mx-auto max-w-6xl">
        <h2 className="text-foreground mb-12 text-center text-4xl font-bold tracking-tight font-display">
          Airports We Service
        </h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {airports.map((airport, i) => <Card key={airport.code} data-index={i} className={`group relative overflow-hidden border border-muted/20 bg-secondary/5 backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:border-muted/40 hover:bg-secondary/10 hover:shadow-strong hover:-translate-y-2 ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0 translate-y-4"}`} style={{
          animationDelay: `${i * 100}ms`
        }}>
              <div className="flex flex-col items-center justify-center gap-4 p-8">
                <Plane className="text-accent transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110" size={48} strokeWidth={1.5} />
                <div className="text-center">
                  <h3 className="text-foreground text-3xl font-bold tracking-wider font-display transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105">
                    {airport.code}
                  </h3>
                  <div className="relative mt-2 overflow-hidden">
                    <span className="text-muted block text-sm">
                      {airport.name}
                    </span>
                    <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}